import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/ProductDetail/:id',
        name: 'ProductDetail',
        component: () => import('@/views/front/components/ProductDetail.vue'),
        props: true
    },
    {
        path: '/login',
        component: () => import('@/views/login/login.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/register',
        component: () => import('@/views/login/register.vue'),
        meta: {
            title: '注册'
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/front/Home.vue'),
        meta: {
            title: 'COG主播可信资产综合服务平台'
        }
    },
    {
        path: '/user/personal',
        name: 'PersonalCenter',
        component: () => import('@/views/user/PersonalCenter.vue'),
        meta: {
            title: '个人中心'
        }
    },
    {
        path: '/user/personal/applications',
        name: 'PersonalApplicationList',
        component: () => import('@/views/user/PersonalApplicationList.vue'),
        meta: {
            title: '我的申请'
        }
    },
    {
        path: '/user/personal/asset-apply',
        name: 'PersonalAssetApplication',
        component: () => import('@/views/user/PersonalAssetApplication.vue'),
        meta: {
            title: '资产评估申请'
        }
    },
    {
        path: '/user/org',
        name: 'OrganizationCenter',
        component: () => import('@/views/user/OrganizationCenter.vue'),
        meta: {
            title: '机构中心'
        }
    },
    {
        path: '/user/org/auth',
        name: 'OrganizationAuth',
        component: () => import('@/views/user/OrganizationAuth.vue'),
        meta: {
            title: '机构身份认证'
        }
    },
    {
        path: '/user/org/talents',
        name: 'OrganizationTalent',
        component: () => import('@/views/user/OrganizationTalent.vue'),
        meta: {
            title: '主播管理'
        }
    },
    {
        path: '/user/org/talents/form',
        name: 'OrganizationTalentForm',
        component: () => import('@/views/user/OrganizationTalentForm.vue'),
        meta: {
            title: '增加主播'
        }
    },
    {
        path: '/user/org/assets',
        name: 'OrganizationAssetApplication',
        component: () => import('@/views/user/OrganizationAssetApplication.vue'),
        meta: {
            title: '机构资产评估'
        }
    },
    {
        path: '/user/org/assets/create',
        name: 'OrganizationAssetApplicationCreate',
        component: () => import('@/views/user/OrganizationAssetApplicationCreate.vue'),
        meta: {
            title: '机构资产评估申请'
        }
    },
    // {
    //     path: '/productService',
    //     name: 'ProductService',
    //     component: () => import('@/views/front/ProductService.vue'),
    //     meta: {
    //         title: '产品与服务'
    //     }
    // },
    // {
    //     path: '/business',
    //     name: 'Business',
    //     component: () => import('@/views/front/Business.vue'),
    //     meta: {
    //         title: '招商'
    //     }
    // },
    // {
    //     path: '/about',
    //     name: 'About',
    //     component: () => import('@/views/front/About.vue'),
    //     meta: {
    //         title: '关于我们'
    //     }
    // },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router

export function resetRouter() {
    router.push({ path: '/login' })
}
